<!-- Inline -->
<div *ngIf="isInline; else default" class="custom-dropdown-wrapper inline-dropdown">
  <span class="inline-label">{{label}}</span>
  <mat-select [(ngModel)]="value" name="item" [disabled]="isDisabled" (selectionChange)="onChange($event)">
    <mat-option *ngFor="let item of data" [value]="getValue(item)">
      {{getText(item)}}
    </mat-option>
  </mat-select>
</div>

<!-- Default -->
<ng-template #default>
  <mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    <mat-select [(ngModel)]="value" name="item" [disabled]="isDisabled" (selectionChange)="onChange($event)">
      <mat-option *ngFor="let item of data" [value]="getValue(item)">
        {{getText(item)}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
